export default __webpack_public_path__ + "static/media/account_ic.7ed2e997.svg";